// extracted by mini-css-extract-plugin
export default {"container":"FloatingIcon_container__7JsHS","avatar":"FloatingIcon_avatar__iLut5","float":"FloatingIcon_float__mSig1"};